(function () {
    "use strict";

    // @ngInject
    function WorkspaceParticipantModalControllerCtor($modalInstance, $scope, $injector, AnalyticsService, UsersManager, UserService, WorkspaceService, participant, workspace, allowActions) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'WorkspaceParticipantModalController';
        AnalyticsService.trackPageView(this, 'WorkspaceParticipantModal');

        this.UserService = UserService;
        this.UsersManager = UsersManager;
        this.WorkspaceService = WorkspaceService;

        this.participant = participant;
        this.workspace = workspace;
        this.allowActions = allowActions;
        this.$modalInstance = $modalInstance;
    }

    Controllers.WorkspaceParticipantModalController = Class(Controllers.BaseController, {

        constructor: WorkspaceParticipantModalControllerCtor,

        close: function close() {
            this.$modalInstance.close();
        },

        onEdit: function onEdit(){
            this.editContactInProgress = true;
            this.UserService.editContact(this.participant).then(function success(resp) {
            }).finally(function () {
                this.editContactInProgress = false;
            }.bind(this));
        },

        removeMember: function removeMember() {
            this.WorkspaceService.removeMemberFromWorkspaceWrapper(this.workspace, this.participant);
            this.close();
        }
    });
}());
